<template>
  <div class="VideoCkplayer" :class="VideoCkplayerName"></div>
</template>
<script>
import moment from "moment";
export default {
  name: "VideoCkplayer",
  props: {
    videourl: {
      //视频源
      type: String,
      default: ""
    },
    filetype: {
      //播放类型
      type: String,
      default: ""
    },
    isLive: {
      //是否直播
      type: Boolean,
      default: false
    },
    isFlashplayer: {
      //是否强制是用flash 不能和isHtml5m3u8同时设置为true
      type: Boolean,
      default: false
    },
    isHtml5m3u8: {
      //是否使用hls 不能和isFlashplayer同时设置为true
      type: Boolean,
      default: false
    },
    index: {
      //多个视频是需要传
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      videoObject: null, //播放器对象
      videoObjectconfig: null //播放器配置对象
    };
  },
  computed: {
    VideoCkplayerName() {
      return "VideoCkplayer" + this.index;
    }
  },
  watch: {
    videourl(val, oldval) {
      if (val) {
        this.newVideo();
      }
    }
  },
  created() {
    //必须挂载在window上
    window["loadedHandler"] = () => {
      this.loadedHandler();
    };
  },
  mounted() {
    this.initPlayer();
  },
  beforeDestroy() {},
  methods: {
    initPlayer() {
      /* 使用手册参考: http://www.chplayer.com/manual/#m3addListener */
      //挂载后创建
      this.ini();
      const player = new ckplayer(this.videoObjectconfig); //创建一个播放器函数并附给player变量，（player需要和 var videoObject里的属性variable相同）

      this.videoObject = player;
      // console.log(player.getStatus());
    },
    //初始化播放器配置对象
    ini() {
      this.videoObjectconfig = {
        container: this.VideoCkplayerName, //容器的ID,如果获到容器定义的是ID则需要增加#，如果是class，则不需要添加或添加.
        variable: "player", //调用函数名称，该属性主要用于flashplayer发送监听内容时使用，如call('player.time',10)
        volume: 0.6, //默认音量，范围是0-1
        poster: "", //封面图片地址
        autoplay: true, //是否自动播放，默认true=自动播放，false=默认暂停状态
        loop: false, //是否循环播放，默认false=不需要,true=需要
        live: this.isLive, //是否是直播，默认false=点播放，true=直播
        loaded: "loadedHandler", //当播放器加载后执行的函数
        seek: 0, //默认需要跳转的时间
        drag: "start", //在flashplayer情况下是否需要支持按关键帧拖动，不需要留空，需要请填写拖动时请求的属性，本例中使用start，如果需要强制按时间点拖动则增加前缀time_，本例中即time_start，如果需要强制按关键帧进行拖动，则前缀是frames_，本例中即：frames_start
        front: "", //前一集按钮点击触发函数，即点击前一集时调用的函数名称，默认为空
        next: "", //下一集按钮点击触发函数，即点击下一集时调用的函数名称，默认为空
        flashplayer: this.isFlashplayer, //强制使用flashplayer
        html5m3u8: this.isHtml5m3u8, //是否使用hls，默认不选择，如果此属性设置成true，则不能设置flashplayer:true,
        track: [
          /* {
          kind: "subtitles",
          label: "English",
          srclang: "en",
          src: "res/zm/cs.vtt",
          default: true
        },
        {
          kind: "subtitles",
          label: "中文",
          srclang: "zn",
          src: "res/zm/cs2.vtt",
          default: false
        } */
        ], //系统内置字幕轨道，目前大部分浏览器都不支持
        chtrack: {
          src: "srt.srt",
          charset: "utf-8"
        }, //chplayer使用的字幕文件及编码 //预览图片地址数组，src=图片地址数组，scale=图片截取时间间隔，单位：秒
        /* preview: {
        src: [
          "screenshot/mydream_en1800_1010_01.jpg",
          "screenshot/mydream_en1800_1010_02.jpg"
        ],
        scale: 2
      }, */ prompt: [
          /* {
          words: "提示点文字01",
          time: 16
        },
        {
          words: "提示点文字02",
          time: 60
        } */
        ], //提示点，words=提示点的内容，time=提示点对应的时间
        debug: false, //是否开启调试模式，默认false，不开启
        /* 播放方式 */
        video: this.videourl //普通文本型，该方式适合调用单个视频的形式
        // video:['examples.mp4','video/mp4','examples.webm','video/webm'], //普通数组型，该方式适合调用单个视频并且有多个格式的形式
        /* video: [ 
        ["examples01.mp4", "video/mp4", "中文标清", 0],
        ["examples02.mp4", "video/mp4", "中文高清", 10],
        ["examples03.mp4", "video/mp4", "英文高清", 0],
        ["examples04.mp4", "video/mp4", "英文超清", 0]
      ] //二维数组-数组型，该方式适合调用有不同清晰度的形式 */
        /* video: {
        //对象型，该方式主要用来不直接显示视频地址时使用，需要注意的是不能跨域调用
        url: this.videourl,
        type: this.filetype //只有当有类型时才需要填写，如果是m3u8或rtmp协议时留空
      } */
      };
    },
    //当播放器加载后执行的函数
    loadedHandler() {
      //播放器加载成功后注册监听
      this.videoObject.addListener("error", this.errorHandler); //监听视频加载出错
      this.videoObject.addListener("screenshot", this.screenshot); //监听截图
    },
    //视频加载出错
    errorHandler() {},
    //截图 html5下可用 调用是传参 1
    screenshot(obj) {
      if (obj === 1) {
        let fileName = moment().format("YYYY-MM-DD") + ".jpg";
        this.videoObject.screenshot("player", false, fileName);
      } else if (obj != 0 && obj != null) {
        let imgData = obj.base64;
      }
    },

    //继续播放
    play() {
      if (this.videoObject != null) {
        this.videoObject.play();
      }
    },
    //暂停
    pause() {
      if (this.videoObject != null) {
        this.videoObject.pause();
      }
    },
    //获取视频源数据
    getMetaDate() {
      if (this.videoObject != null) {
        let MetaDate = this.videoObject.getMetaDate();
        /**
         * MetaDate属性
         * 总时间：duration 秒，
         * 音量： volume（范围0-1），
         * 播放器的宽度：width px，
         * 播放器的高度：height px，
         * 视频的实际宽度：videoWidth px，
         * 视频的实际高度：videoHeight px，
         * 是否暂停状态：paused
         */
      }
    },
    //清除视频播放器
    removeChild() {
      if (this.videoObject != null) {
        this.videoObject.removeChild();
      }
    },
    //切换新视频
    newVideo() {
      if (this.videoObject != null) {
        try {
          //重新获取配置对象
          this.ini();
          this.videoObject.newVideo(this.videoObjectconfig);
        } catch (error) {
          this.initPlayer();
        }
      }
    }
  }
};
</script>
<style lang="scss">
.VideoCkplayer {
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// VideoCkplayer.vue?76d505f1